import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const createTask = ({ churchId, task }) => {
  return axios.post(`/churches/${churchId}/tasks`, task);
};

export const useCreateTask = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("tasks");
      setNotification({
        type: "success",
        message: "Task created successfully!"
      });
    },
    ...config,
    mutationFn: createTask
  });
};
